import { EmailActionContext } from "./EmailActionContext";
import usePrepareEmail from "./usePrepareEmail";
import useEmail from "./useEmail";
import { useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import { t } from "i18next";

function useEmailAction(modelConfig: any, index: any): any {
  const prepareEmail = usePrepareEmail();
  const prepareEmailFunction = (id: any) => prepareEmail(id);

  const onSuccessEmail = () => {
    setShowModal(false);
    index();
  };

  const pay = useEmail(modelConfig);

  const payFunction = () => pay(onSuccessEmail);

  const contextInstance = useContext(EmailActionContext);
  const { setShowModal } = contextInstance;

  const modalConfig = {
    contextInstance: contextInstance,
    title: "send-email",
    onSubmit: () => payFunction(),
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      {t(`are_you_sure_you_want_to_send_the_email_of_this_${modelConfig.modelName}?`)}
    </CrudModuleFactoryModal>
  );

  /** END EDIT TABLE ACTION */

  return {
    prepareEmailFunction,
    actionTemplate,
  };
}

export default useEmailAction;
